module.exports = __webpack_public_path__ + "img/create-upload-1.d271c63a.svg";